var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
var CurrentPotIcon = function (props) {
    return (_jsxs("svg", __assign({ width: "50", height: "50", viewBox: "0 0 50 50", fill: "none", xmlns: "http://www.w3.org/2000/svg" }, props, { children: [_jsx("rect", { width: "50", height: "50", rx: "25", fill: "url(#paint0_linear_9374_25895)" }), _jsx("path", { d: "M13.542 31.2498L25.0003 36.4582L36.4587 31.2498M13.542 24.479L25.0003 29.6873L36.4587 24.479M36.4587 17.7082L25.0003 13.5415L13.542 17.7082L25.0003 22.9165L36.4587 17.7082Z", stroke: "#FCFCFC", "stroke-width": "2", "stroke-linecap": "round", "stroke-linejoin": "round" }), _jsx("defs", { children: _jsxs("linearGradient", { id: "paint0_linear_9374_25895", x1: "-1.67638e-08", y1: "15.25", x2: "51.1509", y2: "19.7936", gradientUnits: "userSpaceOnUse", children: [_jsx("stop", { "stop-color": "#99FE67" }), _jsx("stop", { offset: "1", "stop-color": "#00994D" })] }) })] })));
};
export default CurrentPotIcon;
